import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
interface NumberPillProps {
  id: string;
  label: string;
  subtle?: boolean;
}
export function NumberPill({
  id,
  label,
  subtle = false
}: NumberPillProps) {
  return <motion.div whileTap={{
    scale: 0.95
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-69" data-mp="1vww2zqqctgqk">
      <Link to={`/number/${encodeURIComponent(id)}`} className={['flex items-center justify-center rounded-full border px-4 py-2.5 text-[15px] font-semibold tabular-nums tracking-tight transition-[background-color,border-color,box-shadow,color] duration-200 ease-smooth focus:outline-none focus-visible:ring-2 focus-visible:ring-aura-bright/70', subtle ? 'border-white/10 bg-white/[0.04] text-lav hover:border-aura/50 hover:text-white' : 'border-aura/25 bg-aura/[0.10] text-white hover:border-aura-bright/60 hover:bg-aura/20', 'hover:shadow-[0_0_22px_-6px_rgba(139,92,246,0.8)]'].join(' ')} data-id="element-70" data-mp="1qxt82z438qwb">
        {label}
      </Link>
    </motion.div>;
}